import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  padding: 0 8px;

  &.disabled {
    opacity: 0.4;
    pointer-events: none;
  }

  .label-text {
    color: ${props => props.theme.normalText};
  }

  label.checkbox {
    cursor: pointer;
    display: block;
    font-size: 16px;
    text-transform: none;
    font-weight: 500;
    text-align: center;
    margin-top: 8px;

    input[type='checkbox'] {
      display: none;

      + .label-text:hover:before {
        color: ${props => props.theme.accent};
      }

      + .label-text:before {
        content: '\f096';
        font-family: 'fontAwesome';
        line-height: 1;
        display: inline-block;
        font-size: 26px;
        margin-right: 8px;
        position: relative;
        top: 4px;
        height: 40px;
      }

      :checked + .label-text:before {
        content: '\f14a';
        color: ${props => props.theme.accent};
        animation: tick 150ms ease-in;
      }

      :disabled + .label-text:before {
        content: '\f0c8';
        color: #dddfe6;
      }
    }
  }

  &.light {
    padding: 0;

    .label-text {
      color: #ffffff;
    }

    label.checkbox {
      margin-top: 0;
      font-size: 14px;
      text-align: left;
      white-space: nowrap;
    }

    .label-text {
      display: flex;
      align-items: center;
    }

    /* Round glyphs, so the box follows the pill it sits in */
    label.checkbox input[type='checkbox'] {
      + .label-text:before,
      + .label-text:hover:before,
      :checked + .label-text:before {
        color: #ffffff;
        font-size: 18px;
        height: auto;
        top: 0;
        margin-right: 6px;
      }

      + .label-text:before {
        content: '\f10c';
      }

      :checked + .label-text:before {
        content: '\f058';
      }
    }
  }
`
